<template>
    <div class="w-100">
        <ui-modal 
            ref="modal1" 
            :title="`Utilizar Reserva Anterior Booking - ID: ${booking_id}`"
            size="large"
            @close="ActionSetVisibleModalUtilizarReservaAnterior(false)">
            <div class="w-100">
                <booking-editar-component  
                    :showDataTransporteTerrestreModel="true"    
                    :booking="booking" 
                    :load="load" 
                    :editSemana="false"
                    :allYearWeeks="true"
                    :editAnio="false"
                />
                
            </div>

            <Button
                :text="btnTexto"
                style="margin-bottom: 0px !important;float: right;"
                color="#21831b"
                colorText="#fff"
                icon="far fa-paper-plane"
                title="Crear"
                horizontal
                :width="120"
                :height="40"
                @click.native="crearReserva()"
                :inactive="btnDisabled"
            />
        </ui-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

// Keen UI
import UiModal from "keen-ui/lib/UiModal";

import Button from "../Button";

import BookingEditarComponent from "./BookingEditarComponent.vue";
import {
  getBookingsDeclarados,
  saveReserva,
  getVerMisBookingsPorAceptar,
  getBookingsDeclaradosFiltrados
} from "../../../constants/lineas";
import { getContadorBooking } from "../../../constants/dashboard";

export default {
    props: ["booking", "load","cerrarModal" ,"closeModall"],
    data() {
        return {
            booking_id : "",
            btnTexto: "Crear",
            btnDisabled: false,
        }
    },
    components: {
        UiModal,
        BookingEditarComponent,
        Button
    },
    methods: {
        ...mapActions("lineas", [
            "ActionSetVisibleModalUtilizarReservaAnterior",
            "actionSetDataDatatableBookingsDeclarados",
            "actionSetDatatableVerMisBookingsPorAceptar",
            'ActionSetContadorMenuBookings'
        ]),
        ...mapActions(["ActionSetZindexModal"]),

        openModal(ref) {
            this.$refs[ref].open();
        },

        closeModal(ref) {
            this.$refs[ref].close();
        },
      async crearReserva() {

        const isvalid = this.validar();

        if (!isvalid) return;

        this.ActionSetVisibleModalUtilizarReservaAnterior(false);

        this.estadoButton("Creando...");

        const b = this.booking;

        const form = {
          year: b.year.value.id,
          week: b.week.value.id,
          containers_requested: b.containers_requested.value,
          container_id: b.container_id.value.id,
          port_discharge_id: b.port_discharge_id.value.id,
          port_load_id: b.port_load_id.value.id,
          port_origin_id: b.port_origin_id.value.id,
          port_destination_id: b.port_destination_id.value.id,
          id_client_product: b.id_client_product.value.id,
          emition_bl: b.emition_bl.value,
          stacking_day: null,
          contract: null,
          contrato_booking: b.contract_number.value,
          comment: b.comment.value,
          has_si: (b.has_si.value == 'Si' ? 1 : 0),
          si_type_id: b.si_type_id.value.id,
          vessel: b.vessel.value,
          voyage: b.voyage.value,
          shipper_address_id: b.shipper_address_id.value.id,
          shipper_consignee_id: b.shipper_consignee_id.value.id,
          shipper_notify_id: b.shipper_notify_id.value.id,
          payment_method: b.payment_method.value.id,
          id_client: b.id_client.value.id,
          haulage_movement_type: b.haulage_movement_type.value,
          lugarCargaModel: b.haulage_port_origin_id.value.id,
          fechaRetiroModel: b.haulage_withdrawal_date.value,
          haulage_rampla: b.haulage_rampla.value.name,
          packingModel: b.haulage_packing_id.value.id,
          direccionPackingModel: b.haulage_carrier.value.id,
          itinerary_id: b.itinerary_id.value,
          haulage_cost: b.haulage_cost.value,
          // datos nuevos de ventilacion
          container_temperature: b.container_temperature.value,
          container_cbm_ventilation: b.container_cbm_ventilation.value,
          container_percent_ventilation: b.container_percent_ventilation.value,
          container_atmosphere_id: b.container_atmosphere_id.value.id,
          container_percent_co2: b.container_percent_co2.value,
          container_percent_o2: b.container_percent_o2.value,
          container_cold_treatment: (b.container_cold_treatment.value === "Si"),
          planned: 0,
          shipper_id: b.shipper_id.value.id,
          tariff_contract_id: b.contract.value.id
        };

        this.$vToastify.loader("Creando Booking...");

        let sql = await saveReserva(form);

        if (!sql.error) {

          if (this.flagFiltersBookings) {

            let data = await getBookingsDeclaradosFiltrados(this.currentFiltersBookings);

            this.actionSetDataDatatableBookingsDeclarados(data);

          } else {

            let { data_table } = await getBookingsDeclarados();

            this.actionSetDataDatatableBookingsDeclarados(data_table);

          }

          await this.actualizarCount();

          this.$vToastify.stopLoader();

          this.closeModal("modal1");

          this.closeModall("modal");

          this.estadoButton("Crear", false);

          const user = JSON.parse(localStorage.getItem("user"));

          if (this.url_actual !== "/lineas/booking/bookings_declarados" && this.isAdmin) {

            await this.$router.push({ path: "/lineas/booking/bookings_declarados" });

          }

          if (this.url_actual !== "/lineas/booking/ver_bookings_por_aceptar" && user.id_role !== 1 && user.id_role !== 9999 && user.id_role !== 2 && user.id_role !== 5) {

            await this.$router.push({ path: "/lineas/booking/ver_bookings_por_aceptar" });

          } else {

            if (user.id_role !== 1 && user.id_role !== 9999 && user.id_role !== 2 && user.id_role !== 5) {

              let dataPorAceptar = await getVerMisBookingsPorAceptar();

              this.actionSetDatatableVerMisBookingsPorAceptar(dataPorAceptar.data_table);

            }

          }

          this.$vToastify.success("Reserva realizada con éxito", "Éxito");

          return;

        }

        this.estadoButton("Crear", false);

        this.$vToastify.stopLoader();

        this.$vToastify.error(
          "No fue posible realizar la reserva, recargue la página y vuelva intentar.",
          "Lo sentimos"
        );
      },

        estadoButton( text, estado = true ){
            this.btnTexto = text ;
            this.btnDisabled = estado ;
        } ,
        async actualizarCount(){
            const contadores = await getContadorBooking();
            this.ActionSetContadorMenuBookings(contadores[0]);
        },
        validar() {
            const b = this.booking;

            if (!b.year.value.id) {
                this.$vToastify.error("Año no puede estar vacío", "Lo sentimos");
                return false;
            }

            if (!b.week.value) {
                this.$vToastify.error("Semana no puede estar vacío", "Lo sentimos");
                return false;
            }

            if (!b.port_load_id.value.id) {
                this.$vToastify.error(
                "Puerto de Embarque debe estar seleccionado",
                "Lo sentimos"
                );
                return false;
            }
            if (!b.port_origin_id.value.id) {
                this.$vToastify.error(
                "Lugar de origen debe estar seleccionado",
                "Lo sentimos"
                );
                return false;
            }

            if (!b.port_discharge_id.value.id) {
                this.$vToastify.error(
                "Puerto de descarga debe estar seleccionado",
                "Lo sentimos"
                );
                return false;
            }

            if (!b.port_destination_id.value.id) {
                this.$vToastify.error(
                "Lugar de Destino Final debe estar seleccionado",
                "Lo sentimos"
                );
                return false;
            }

            if (!b.vessel.value) {
                this.$vToastify.error("Nave no puede estar vacío", "Lo sentimos");
                return false;
            }

            if (!b.voyage.value) {
                this.$vToastify.error("Viaje no puede estar vacío", "Lo sentimos");
                return false;
            }

            if (b.has_si.value == "Si") {
                if (!b.si_type_id.value.id) {
                this.$vToastify.error(
                    "Tipo Servicio Integral debe estar seleccionado ",
                    "Lo sentimos"
                );
                return false;
                }
            }

            if (!b.shipper.value.id) {
                this.$vToastify.error("Shipper debe estar seleccionado", "Lo sentimos");
                return false;
            }

            if (!b.shipper_address_id.value.id) {
                this.$vToastify.error(
                "Dirección shipper debe estar seleccionado",
                "Lo sentimos"
                );
                return false;
            }

            if (b.containers_requested.value == "0") {
                this.$vToastify.error(
                "Cantidad de contenedores a solicitar debe ser mayor a 0",
                "Lo sentimos"
                );
                return false;
            }

            if (b.containers_requested.value < "0") {
                this.$vToastify.error(
                "No se admiten valores negativos ",
                "Lo sentimos"
                );
                return false;
            }

            //Reefer
            if (b.type_container.value == "Reefer") {
                if (!b.container_temperature.value) {
                    this.$vToastify.error(
                        "Temperatura °C no puede estar vacío",
                        "Lo sentimos"
                    );
                    return false;
                }
                if (!b.container_percent_ventilation.value) {
                    this.$vToastify.error(
                        "% Ventilación no puede estar vacío",
                        "Lo sentimos"
                    );
                    return false;
                }
                if (!b.container_cbm_ventilation.value) {
                    this.$vToastify.error(
                        "Ventilación CBM no puede estar vacío",
                        "Lo sentimos"
                    );
                    return false;
                }
                if (!b.container_cold_treatment.value) {
                    this.$vToastify.error(
                        "Con Cold Treatment no puede estar vacío",
                        "Lo sentimos"
                    );
                    return false;
                }
            }

            if ( b.with_ac.value ) {
                if (!b.container_atmosphere_id.value.id) {
                this.$vToastify.error(
                    "Atmósfera controlada debe estar seleccionado",
                    "Lo sentimos"
                );
                return false;
                }

                if (!b.container_percent_o2.value) {
                this.$vToastify.error(
                    "% Oxígeno (O2) no debe quedar vacío",
                    "Lo sentimos"
                );
                return false;
                }

                if (!b.container_percent_co2.value) {
                this.$vToastify.error("% CO2 no debe quedar vacío", "Lo sentimos");
                return false;
                }
            }

            if (!b.payment_method.value) {
                this.$vToastify.error(
                "Forma de pago debe estar seleccionado",
                "Lo sentimos"
                );
                return false;
            }

            if (!b.contract.value) {
                this.$vToastify.error("Contrato no debe estar vacío", "Lo sentimos");
                return false;
            }

            if (!b.emition_bl.value) {
                this.$vToastify.error(
                "Emisión de BL no debe quedar vacío",
                "Lo sentimos"
                );
                return false;
            }

            return true;
        },
    },
    computed: {
        ...mapState("lineas", [
            "visibleModalUtilizarReservaAnterior",
            "flagFiltersBookings",
            "currentFiltersBookings"
        ]),
        ...mapState([
            "isAdmin",
            "url_actual"
        ]),
    },

    watch: {
        visibleModalUtilizarReservaAnterior: function (_new) {
            if (_new) {
                (_new) 
                ? this.openModal("modal1")
                : this.closeModal("modal1");
            }
        },
        booking: function( _new ) {
            if (_new) {
                this.booking_id = _new.id.value ;
            }
        }
    }
}

</script>